import { useAgentHistory } from "@/context/agent/useAgentHistory.ts";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export const useAgentChatUi = () => {
  const { isOpen, open: openChat, close: closeChat, toggle: toggleChat } = useAgentHistory();
  const { i18n } = useTranslation();
  const [key, setKey] = useState(Date.now);

  useEffect(() => {
    const handleLanguageChange = () => setKey(Date.now());
    i18n.on('languageChanged', handleLanguageChange);
    return () => { i18n.off('languageChanged', handleLanguageChange); };
  }, []);

  const toggle = () => {
    setKey(Date.now());
    toggleChat();
  };

  const open = () => {
    setKey(Date.now());
    openChat();
  };

  const close = () => {
    setKey(Date.now());
    closeChat();
  };

  return { isOpen, open, close, toggle, key };
};
